import { ActionIcon, Box } from '@mantine/core';
import useAiAnalystContext from '@providers/AiAnalyst/useAiAnalystContext';
import { IconArrowDown } from '@tabler/icons-react';
import { useCallback, useMemo, useRef, useState } from 'react';
import Messages from '../Messages';

const ChatWithMessages: React.FC = () => {
    const { aiChatMessages, activeThread, isStreaming } = useAiAnalystContext(
        (context) => context.state,
    );
    const threadId = activeThread?.threadId;

    const [showScrollButton, setShowScrollButton] = useState(false);
    const scrollToBottom = useRef<(() => void) | null>(null);

    const handleScrollToBottom = useCallback(() => {
        if (scrollToBottom.current) scrollToBottom.current();
    }, []);

    const renderScrollButton = useMemo(() => {
        const shouldShow =
            (aiChatMessages.length > 0 || isStreaming) &&
            (showScrollButton || isStreaming);
        if (!shouldShow) return null;
        return (
            <ActionIcon
                onClick={handleScrollToBottom}
                size="lg"
                variant="filled"
                color="gray"
                className="fixed bottom-28 right-6 z-50 rounded-full shadow-lg hover:shadow-xl active:scale-95"
            >
                <IconArrowDown size={18} />
            </ActionIcon>
        );
    }, [aiChatMessages.length, showScrollButton, handleScrollToBottom, isStreaming]);

    return (
        <Box className="flex h-full min-h-0 w-full justify-center">
            <Box className="flex h-full min-h-0 w-full max-w-5xl flex-col gap-2">
                <Messages
                    chatId={threadId ?? ''}
                    onScrollStatusChange={setShowScrollButton}
                    setScrollToBottom={(fn) => {
                        scrollToBottom.current = fn;
                    }}
                />

                {renderScrollButton}
            </Box>
        </Box>
    );
};

export default ChatWithMessages;
